module.exports = __webpack_public_path__ + "img/boat.5dc2afeb.jpg";